import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GotoTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Ensure scroll restoration is manual
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    // Delay scroll to allow rendering to complete
    const timeout = setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "auto" });
    }, 50); // Slight delay helps in Firefox

    return () => clearTimeout(timeout);
  }, [pathname]);

  return null;
};

export default GotoTop;